module.exports = __webpack_public_path__ + "static/media/whistledog-en.0b3ae272.jpg";